// [PURPOSE]: Reactive mobile detection hook using matchMedia
// [WHY]: Static window.innerWidth check doesn't update on resize/rotation
// [INTEGRATION]: Replaces all `window.innerWidth < 768` checks
// [PERF]: Uses matchMedia — fires only on breakpoint cross, no debouncing needed

import { useState, useEffect } from 'react';

const MOBILE_BREAKPOINT = '(max-width: 767px)';

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(MOBILE_BREAKPOINT).matches;
  });

  useEffect(() => {
    const mql = window.matchMedia(MOBILE_BREAKPOINT);

    const handleChange = (e) => {
      setIsMobile(e.matches);
    };

    // Modern browsers use addEventListener, older use addListener
    if (mql.addEventListener) {
      mql.addEventListener('change', handleChange);
    } else {
      mql.addListener(handleChange);
    }

    // Sync initial state
    setIsMobile(mql.matches);

    return () => {
      if (mql.removeEventListener) {
        mql.removeEventListener('change', handleChange);
      } else {
        mql.removeListener(handleChange);
      }
    };
  }, []);

  return isMobile;
};

export default useIsMobile;
